import React, { useEffect, useState } from 'react';
import { useAccess } from '@umijs/max';
import { Button } from 'antd';

export type ProButtonType = {
    auth?: string
    hide?: string
    disabled?: boolean
    custom?: boolean
    onClick?: () => Promise<void>
    title?: any
    fieldProps?: any
}

const ProButton = (props: any) => {
    const access = useAccess();
    let [auth, setauth] = useState()
    useEffect(() => {
        init()
    }, [])
    const init = async () => { 
        if (props.auth) {
            let res =  (await access).canReadButton(props.auth)
            setauth(res)
        }
    }

    return (
            <span>
                {
                    [
                        (!auth && props.disabled !== undefined) && <Button style={{width: '20px'}} disabled={true} {...props.fieldProps} onClick={props.onClick}>
                            {props.title}
                        </Button>,
                        (auth && props.disabled === undefined  && !props.custom) && <Button style={{width: '20px'}} {...props.fieldProps} onClick={props.onClick}>
                            {props.title}
                        </Button>,
                        (auth && props.disabled === undefined && props.custom) && <div>
                            {props.children}
                        </div>
                    ]
                }
            </span>
    )
}
export default ProButton